import { bridgeDescriptor } from '@cardforest/games/games/bridge/descriptor.js';
import { ginRummyDescriptor } from '@cardforest/games/games/gin-rummy/descriptor.js';
import { heartsDescriptor } from '@cardforest/games/games/hearts/descriptor.js';
import { spadesDescriptor } from '@cardforest/games/games/spades/descriptor.js';
import type { MDXProps } from 'mdx/types';
import type { ComponentType } from 'react';

export interface RulesModule {
  default: ComponentType<MDXProps>;
  headings: readonly { id: string; text: string; depth: number }[];
}

const documents: Readonly<Record<string, () => Promise<RulesModule>>> = {
  [bridgeDescriptor.gameId]: () => import('./games/bridge/bridge.rules.mdx'),
  [ginRummyDescriptor.gameId]: () => import('./games/gin-rummy/gin-rummy.rules.mdx'),
  [heartsDescriptor.gameId]: () => import('./games/hearts/hearts.rules.mdx'),
  [spadesDescriptor.gameId]: () => import('./games/spades/spades.rules.mdx'),
};

export function hasGameRules(gameId: string): boolean {
  return Object.hasOwn(documents, gameId);
}

export async function loadGameRules(gameId: string): Promise<RulesModule> {
  if (!hasGameRules(gameId)) throw new Error(`No rules document is registered for ${gameId}.`);
  return documents[gameId]();
}
